<div *ngIf="showNotification" class="notification-container">
    <div class="notification-icon">↑</div>
    <h2 class="notification-title">Update Available</h2>
    <p class="notification-message">
        A new version of the portal is available with improved features and bug fixes. 
        Update now to get the latest experience.
    </p>
    <div class="button-container">
        <button (click)="updateNow()" class="update-button">Update Now</button>
        <button (click)="remindLater()" class="skip-button">Remind Me Later</button>
    </div>
</div>
